import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";

function BlogArticleMainData(props: ObjectFieldTemplateProps, func: any) {
  const { actionTemplate } = useUpdateSectionAction();
  return (
    <>
      <div className="cms-section">
        <div className="h3">{props.title} {actionTemplate}</div>
        <div className="section row">
          <div className="col-6">
            <div className="property-wrapper">
              {func("lecture_time", props)?.content}
            </div>
          </div>
          <div className="col-6">
            <div className="property-wrapper">
              {func("editor_id", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("subtitle", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogArticleMainData;
